// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_mats_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Experience comfort with kybun mats`
};

const el_mats_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Απολαύστε άνεση με τα χαλάκια kybun`
};

const ru_mats_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Ощутите комфорт с ковриками kybun`
};

const he_mats_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `חוו נוחות עם מזרוני kybun`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mats_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mats_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("mats_subtitle", locale)
	if (locale === "en") return en_mats_subtitle(inputs)
	if (locale === "el") return el_mats_subtitle(inputs)
	if (locale === "ru") return ru_mats_subtitle(inputs)
	if (locale === "he") return he_mats_subtitle(inputs)
	return "mats_subtitle"
};